module.exports = __webpack_public_path__ + "static/media/ratios.3251e41c.png";